/* woz_yml.js – observer-safe, variant dropdown, reviews, compare-at price */
(function () {
  console.log('[YML] script loaded');

  /* ────── 0 · globals ────── */
  const drawer     = document.getElementById('CartDrawer');
  const wrapperId  = 'yml-wrapper';
  const gridId     = 'yml-cards';
  let   lastHash   = '';
  let   drawerObs;                               // MutationObserver ref

  /* ────── 1 · first paint ────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildYML);
  } else { buildYML(); }

  /* ────── 2 · one reliable theme event ────── */
  document.addEventListener('cart:updated', e => {               // Dawn ≥10
    console.log('[YML] cart:updated event'); buildYML();
  });

  /* ────── 3 · fallback observer (disconnect-safe) ────── */
  if (drawer) {
    drawerObs = new MutationObserver(muts => {
      if (muts.some(r => r.addedNodes.length || r.removedNodes.length)) {
        console.log('[YML] observer → drawer changed'); buildYML();
      }
    });
    drawerObs.observe(drawer, { childList:true, subtree:true });
  }

  // /* ────── 4 · main routine ────── */
  // async function buildYML () {
  //   drawerObs?.disconnect();                           // prevent self-loop
  //   console.log('[YML] buildYML start');

  //   // const items = [...drawer.querySelectorAll('.cart__item[data-yml]')];
  //   const items     = [...drawer.querySelectorAll('.cart__item[data-yml]')];
  //   console.log('[YML] items found:', items.length);
  //   if (!items.length) { hideWidget(); resumeObs(); return; }

  //   // const inCart = items.map(el => el.dataset.productId);
  //   const inCartSet = new Set(items.map(el => el.dataset.productHandle)); // handles
  //   console.log("In Cart YML:" + inCartSet);
  //   const pool   = items.flatMap(el => {
  //     try { return JSON.parse(el.dataset.yml || '[]'); }
  //     catch { console.warn('[YML] bad JSON', el.dataset.yml); return []; }
  //   });

  //   console.log("YML Pool" + pool);

  //   // const picks  = [...new Set(pool)]
  //   //                 .filter(h => !inCart.includes(h))
  //   const picks = [...new Set(pool)]
  //                   .filter(h => !inCartSet.has(h))    // handle vs handle
  //                   .slice(0, 2);
  //   console.log('[YML] picks:', picks);
  //   if (!picks.length) { hideWidget(); resumeObs(); return; }

  //   const hash = picks.join('|');
  //   if (hash === lastHash) { console.log('[YML] same picks – skip'); resumeObs(); return; }
  //   lastHash = hash;

  //   const host = document.getElementById(wrapperId);
  //   host.classList.remove('hidden');
  //   host.querySelector('#' + gridId).innerHTML =
  //     (await Promise.all(picks.map(renderCard))).join('');

  //   resumeObs();
  // }

  /* ────── 4 · main routine ────── */
  // async function buildYML () {
  //   drawerObs?.disconnect();                       // prevent self-loop
  //   console.log('[YML] buildYML ⟶ start');
  
  //   /* 0 ▸ grab cart line-items that expose YML data */
  //   const items = [...drawer.querySelectorAll('.cart__item[data-yml]')];
  //   console.log('[YML] items found:', items.length, items.map(el => el.dataset.productHandle));
  //   if (!items.length) { hideWidget(); resumeObs(); return; }
  
  //   /* 1 ▸ prepare helpers */
  //   const inCartSet = new Set(items.map(el => el.dataset.productHandle));   // handles
  //   console.log('[YML] in-cart handles:', [...inCartSet]);
  
  //   const pool = items.flatMap(el => {
  //     try   { return JSON.parse(el.dataset.yml || '[]'); }
  //     catch { console.warn('[YML] bad JSON', el.dataset.yml); return []; }
  //   });
  //   console.log('[YML] raw YML pool:', pool);
  
  //   /* 2 ▸ choose “cart size + 2” distinct handles not already in cart */
  //   const need       = items.length + 2;
  //   const candidates = [...new Set(pool)]
  //                       .filter(h => !inCartSet.has(h))
  //                       .slice(0, need);
  //   console.log(`[YML] candidates (need = ${need}):`, candidates);
  
  //   /* 3 ▸ render until we have exactly TWO usable cards */
  //   const cards = [];
  //   for (const handle of candidates) {
  //     if (cards.length === 2) break;               // we’re done
  //     const html = await renderCard(handle);
  //     if (html) {
  //       cards.push(html);
  //       console.log('[YML] added card for', handle);
  //     } else {
  //       console.log('[YML] skipped (sold-out?)', handle);
  //     }
  //   }
  //   console.log('[YML] final card count:', cards.length);
  
  //   /* 4 ▸ show / hide widget */
  //   const host = document.getElementById(wrapperId);
  //   if (!cards.length) { hideWidget(); resumeObs(); return; }
  
  //   /* 5 ▸ dedupe reloads */
  //   const renderedHandles = cards.map(c => c.match(/data-handle="([^"]+)"/)[1]);
  //   const hash            = renderedHandles.join('|');
  //   console.log('[YML] rendered handles:', renderedHandles);
  //   if (hash === lastHash) { console.log('[YML] same picks – skip'); resumeObs(); return; }
  //   lastHash = hash;
  
  //   /* 6 ▸ inject HTML and resume observer */
  //   host.classList.remove('hidden');
  //   host.querySelector('#' + gridId).innerHTML = cards.join('');
  //   resumeObs();
  // }

  /* ────── 4 · main routine ────── */
async function buildYML () {
  /* pause observer so we don’t self-trigger */
  drawerObs?.disconnect();
  console.log('[YML] buildYML ⟶ start');

  /* 0 ▸ cart items that expose YML data */
  const items = [...drawer.querySelectorAll('.cart__item[data-yml]')];
  console.log('[YML] items found:', items.length,
              items.map(el => el.dataset.productHandle));
  if (!items.length) { hideWidget(); resumeObs(); return; }

  /* 1 ▸ build helper sets */
  const inCartSet = new Set(items.map(el => el.dataset.productHandle));   // handles
  console.log('[YML] in-cart handles:', [...inCartSet]);

  /* 2 ▸ pool = all metafield handles, de-duplicated & not-in-cart */
  const pool = [...new Set(
                  items.flatMap(el => {
                    try   { return JSON.parse(el.dataset.yml || '[]'); }
                    catch { console.warn('[YML] bad JSON', el.dataset.yml); return []; }
                  })
                )].filter(h => !inCartSet.has(h));
  console.log('[YML] pool after de-dup & filter:', pool);

  /* 3 ▸ walk the pool until we’ve rendered TWO usable cards */
  const cards = [];
  for (let i = 0; i < pool.length && cards.length < 2; i++) {
    const handle = pool[i];
    const html   = await renderCard(handle);        // '' if sold-out
    if (html) {
      cards.push(html);
      console.log('[YML] added card for', handle);
    } else {
      console.log('[YML] skipped (sold-out?)', handle);
    }
  }
  console.log('[YML] final card count:', cards.length);

  /* 4 ▸ show / hide widget */
  const host = document.getElementById(wrapperId);
  if (!cards.length) { hideWidget(); resumeObs(); return; }

  /* 5 ▸ dedupe consecutive renders */
  const renderedHandles = cards.map(c => c.match(/data-handle="([^"]+)"/)[1]);
  const hash            = renderedHandles.join('|');
  console.log('[YML] rendered handles:', renderedHandles);
  if (hash === lastHash) { console.log('[YML] same picks – skip'); resumeObs(); return; }
  lastHash = hash;

  /* 6 ▸ inject HTML and resume observer */
  host.classList.remove('hidden');
  host.querySelector('#' + gridId).innerHTML = cards.join('');
  resumeObs();
}

  /* ────── 5 · card renderer ────── */
  async function renderCard (handle) {
    console.log('[YML] fetching', handle);
    try {
      const p      = await fetch(`/products/${handle}.js`).then(r => r.json());
      const varOK  = p.variants.filter(v => v.available);
      if (!varOK.length) return '';                 // all sold-out

      /* money helper */
      const fmt = cents => (cents/100).toLocaleString(
          document.documentElement.lang || undefined,
          { style:'currency', currency: Shopify?.currency?.active || 'USD' });

      /* build <select> */
      const selectHTML = varOK.length > 1
        ? `<select class="yml-select">${varOK.map(v =>
             `<option value="${v.id}" data-price="${v.price}"
                      data-compare="${v.compare_at_price||''}">
                ${v.title}
              </option>`).join('')}</select>`
        : `<input type="hidden" class="yml-select" value="${varOK[0].id}"
                    data-price="${varOK[0].price}"
                    data-compare="${varOK[0].compare_at_price||''}">`;

      /* price block (first variant as default) */
      const base   = fmt(varOK[0].price);
      const was    = varOK[0].compare_at_price
                     ? `<span class="yml-was">${fmt(varOK[0].compare_at_price)}</span>` : '';

      /* review badge placeholder */
      const reviews = `
        <!-- Stamped – Begin Star Rating Badge -->
        <span
          class="stamped-product-reviews-badge"
          data-id="${p.id}"
          data-product-sku="${p.handle}"
          data-product-type="${p.type}"
          data-product-title="${p.title}"
          style="display:block;">
        </span>
        <!-- Stamped – End Star Rating Badge -->
      `;

      return /*html*/`
        <div class="yml-card" data-handle="${handle}">
          <a href="${p.url}" class="yml-imgwrap">
            <img src="${p.featured_image}" alt="${p.title}"
                 class="yml-card__img" loading="lazy">
          </a>

          <a href="${p.url}" class="yml-card__title">${p.title}</a>
          ${reviews}

          <div class="yml-card__price">${base}${was}</div>
          ${selectHTML}

          <button type="button" class="yml-add btn">Add&nbsp;to&nbsp;cart</button>
        </div>`;
    } catch (e) {
      console.error('[YML] fetch failed for', handle, e);
      return '';
    }
  }

  /* ────── 6 · delegation for variant change + add-to-cart ────── */
  document.addEventListener('change', e => {
    if (!e.target.matches('.yml-select')) return;
    const opt   = e.target.selectedOptions[0];
    const card  = e.target.closest('.yml-card');
    const price = card.querySelector('.yml-card__price');
    price.innerHTML =
      (opt.dataset.compare && Number(opt.dataset.compare) > Number(opt.dataset.price)
         ? `<span class="yml-now">${money(opt.dataset.price)}</span><span class="yml-was">${money(opt.dataset.compare)}</span>`
         : money(opt.dataset.price));
  });

  // document.addEventListener('click', async e => {
  //   if (!e.target.matches('.yml-add')) return;
  //   const card   = e.target.closest('.yml-card');
  //   const sel    = card.querySelector('.yml-select');
  //   const id     = sel.value || sel.selectedOptions[0].value;
  //   console.log('[YML] add to cart', id);

  //   await fetch('/cart/add.js',{
  //     method:'POST',
  //     headers:{'Content-Type':'application/json'},
  //     body:JSON.stringify({id,quantity:1})
  //   });
  //   document.dispatchEvent(new CustomEvent('cart:updated'));
  // });
  document.addEventListener('click', async e => {
  if (!e.target.matches('.yml-add')) return;

  const card = e.target.closest('.yml-card');
  const sel  = card.querySelector('.yml-select');
  const id   = sel.value || sel.selectedOptions[0].value;

  /* 1 ▸ add the item */
  const res  = await fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id, quantity:1})
  });
  const cart = await res.json();          // Dawn likes the cart JSON

  /* 2 ▸ update any listeners that rely on the event */
  // document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
  document.dispatchEvent(
    new CustomEvent('ajaxProduct:added', { detail: { cart } })
  );

  /* 3 ▸ open / refresh the cart drawer (Dawn ≥10) */
  const drawer = document.querySelector('cart-drawer');
  if (drawer?.open) drawer.open(cart);         // preferred
  else document.dispatchEvent(new CustomEvent('cart:open')); // fallback
});

  function money(cents){return (cents/100).toLocaleString(undefined,{
           style:'currency',currency:Shopify?.currency?.active||'USD'});}

  /* ────── 7 · helpers ────── */
  function hideWidget(){
    const host=document.getElementById(wrapperId);
    host&&host.classList.add('hidden'); lastHash='';
  }
  function resumeObs(){ drawerObs?.observe(drawer,{childList:true,subtree:true}); }

})();
